import { RootState } from "rootReducer";

export const selectQuickEdits = (state: RootState) =>
  state.campaigns.quickEdits;

export const selectCampaignsQuickEdits = (state: RootState) =>
  state.campaigns.quickEdits.campaignEdits;

export const selectLineItemsQuickEdits = (state: RootState) =>
  state.campaigns.quickEdits.lineItemEdits;

// this is to avoid pagination issues
export const selectPersistedQuickEditsData = (state: RootState) => ({
  campaigns: state.campaigns.quickEdits.persistedCampaigns,
  lineItems: state.campaigns.quickEdits.persistedLineItems
});
